module.exports = __webpack_public_path__ + "static/media/savvy-distributions.131dd85e.svg";